import type { LucideIcon } from 'lucide-react';
import {
  Briefcase,
  CalendarCheck,
  Camera,
  Code2,
  GraduationCap,
  Mail,
  MessageCircle,
  MessagesSquare,
  ShoppingBag,
  Sparkles,
  Stethoscope,
} from 'lucide-react';
import type { MessageKey } from '@/i18n';

/** Business types the landing page and /playbook speak to — URL slugs. */
export const BUSINESS_KINDS = ['ecommerce', 'services', 'coaching', 'courses', 'saas', 'creators'] as const;
export type BusinessKind = (typeof BUSINESS_KINDS)[number];

export function isBusinessKind(value: string | undefined): value is BusinessKind {
  return typeof value === 'string' && (BUSINESS_KINDS as readonly string[]).includes(value);
}

export const KIND_ICON: Record<BusinessKind, LucideIcon> = {
  ecommerce: ShoppingBag,
  services: Stethoscope,
  coaching: Briefcase,
  courses: GraduationCap,
  saas: Code2,
  creators: Sparkles,
};

export interface NavItem {
  label: MessageKey;
  desc?: MessageKey;
  href: string;
  icon: LucideIcon;
}

export const PRODUCT_ITEMS: NavItem[] = [
  { label: 'landing.nav.p.instagram', desc: 'landing.nav.p.instagramDesc', href: '/channels', icon: Camera },
  { label: 'landing.nav.p.whatsapp', desc: 'landing.nav.p.whatsappDesc', href: '/channels', icon: MessageCircle },
  { label: 'landing.nav.p.messenger', desc: 'landing.nav.p.messengerDesc', href: '/channels', icon: MessagesSquare },
  { label: 'landing.nav.p.email', desc: 'landing.nav.p.emailDesc', href: '/channels', icon: Mail },
  { label: 'landing.nav.p.booking', desc: 'landing.nav.p.bookingDesc', href: '/flows', icon: CalendarCheck },
];

export const USE_CASE_ITEMS: NavItem[] = BUSINESS_KINDS.map((kind) => ({
  label: `landing.useCases.${kind}`,
  href: `/playbook/${kind}`,
  icon: KIND_ICON[kind],
}));

/** Every section id on the page — the Playwright check asserts each exists. */
export const SECTION_IDS = ['hero', 'channels', 'flows', 'demo', 'use-cases', 'metrics', 'compare', 'faq', 'get-started'] as const;

/** Path → landing section id. Direct URLs (/faq, /channels, /flows) scroll here. */
export const LANDING_SECTION_PATHS: Record<string, (typeof SECTION_IDS)[number]> = {
  '/faq': 'faq',
  '/channels': 'channels',
  '/flows': 'flows',
};
